import {makeStyles, Typography} from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import request from "../../../../../../../../Services/API/Requests";
import {useEffect, useState} from "react";
import clsx from "clsx";
import {Loading} from "../../../../../../../../Utils/Loading/Loading";

const useStyles = makeStyles((theme) => ({
    container: {
        maxHeight: 550,
        overflow: 'auto',
        width: '90%',
        height: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: "row",
        justifyContent: 'flex-start',
        columnGap: "20px",
        rowGap: "20px",
        padding: '15px 10px'
    },
    item: {
        overflow: 'hidden',
        position: 'relative',
        cursor: "pointer",
        flexBasis: '45%',
        width: '250px',
        height: 170,
        border: '1px solid #bebebe',
        borderRadius: 5,
        background: '#e7e7e7'
    },
    itemSelected: {
        borderColor: theme.palette.primary.main
    }
}))

const TemplatesGrid = ({isOpen, onSelectTemplate, selectedFilter, textFilter}) => {
    const classes = useStyles();
    const [selectedTemplate, setSelectedTemplate] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState({content: []})
    useEffect(() => {
        if (isOpen) {
            getInitialData();
        }

    }, [isOpen, selectedFilter, textFilter])

    async function getInitialData() {
        try {
            setIsLoading(true)
            const res = await request({
                url: "/list/getData",
                data: {
                    id: "screenTemplatesDefaultList",
                    pageSize: 99,
                    pageNumber: 1,
                    textFilter,
                    advancedFilter: selectedFilter ? [{
                        field: 'screenTemplateGroup',
                        operand: 'equal',
                        value: selectedFilter || ""
                    }] : undefined
                }
            })
            setIsLoading(false)
            console.log(res)
            setData(res);
        } catch (e) {
            console.log('init templates error', e);
            setIsLoading(false)
        }
    }

    return (
        <div className={classes.container} style={{
            position: 'relative'
        }}>
            <div className={clsx(classes.item, {[classes.itemSelected]: !selectedTemplate})}
                 onClick={() => {
                     onSelectTemplate(undefined)
                     setSelectedTemplate(undefined)
                 }}
            >
                <div style={{
                    width: '100%',
                    height: 135,
                    backgroundPosition: 'center center',
                    backgroundSize: "contain",
                    backgroundRepeat: "no-repeat",
                    background: '#bebebe',
                    padding: 10,
                }}>
                    <EmptyItem/>
                </div>
                <Divider/>
                <div style={{padding: 6, background: '#fff', textAlign: 'center'}}>
                    <Typography align={"center"} variant={"caption"} color={"textSecondary"}>
                        Empty
                    </Typography>
                </div>
            </div>
            {
                isLoading && (
                    <Loading/>
                )
            }
            {data.content.map(item => {
                const isSelected = selectedTemplate === item.id;
                return (
                    <div key={item.id}
                         className={clsx(classes.item, {[classes.itemSelected]: isSelected})}
                         onClick={() => {
                             onSelectTemplate(item.id)
                             setSelectedTemplate(item.id)
                         }}
                    >
                        <div style={{
                            width: '100%',
                            height: 135,
                            backgroundPosition: 'center center',
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundImage: `url(${item.thumbnail})`
                        }}>

                        </div>
                        <Divider/>
                        <div style={{padding: 6, background: '#fff', textAlign: 'center'}}>
                            <Typography align={"center"} variant={"caption"} color={"textSecondary"}>
                                {item.name}
                            </Typography>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default TemplatesGrid;

const EmptyItem = () => {
    return (
        <>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between'
            }}>
                <div style={{
                    paddingTop: 10,
                    width: '30%',
                    height: 10,
                    border: '1px solid',
                    borderRadius: 5,
                    borderColor: '#a8a8a8'
                }}>
                </div>
                <div style={{
                    paddingTop: 10,
                    width: '30%',
                    height: 10,
                    border: '1px solid',
                    borderRadius: 5,
                    borderColor: '#a8a8a8'
                }}>
                </div>
                <div style={{
                    paddingTop: 10,
                    width: '30%',
                    height: 10,
                    border: '1px solid',
                    borderRadius: 5,
                    borderColor: '#a8a8a8'
                }}>
                </div>
            </div>
            <div style={{
                marginTop: 10,
                width: '100%',
                height: 60,
                border: '1px solid',
                borderRadius: 10,
                borderColor: '#a8a8a8'
            }}>
            </div>

        </>
    )
}